module.exports = __webpack_public_path__ + "img/Baumkarte.1da8cc23.jpg";